module.exports = __webpack_public_path__ + "media/svg-new/designer3-565f8ac4.svg";